import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'; // Импорт Bootstrap CSS
import './app.scss';
import App from './App';
import { init, backButton, miniApp } from '@telegram-apps/sdk-react';

if (window.Telegram?.WebApp) {
  init();
  
  backButton.mount();
  backButton.show();
  miniApp.mount();
  miniApp.setBackgroundColor('#000000');
} else {
  console.warn('Not running inside Telegram WebApp');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
